import { ref } from 'vue'

/**
 * Composable para gerenciar o modal de paciente (visualização, edição, cadastro).
 * @param {{ sanitizePaciente?: (p: import('@/types/api').Paciente) => import('@/types/api').Paciente }} options
 */
export function usePacienteModal(options = {}) {
  const mostrarModal = ref(false)
  const modoEdicao = ref(false)
  const modoCadastro = ref(false)
  /** @type {import('vue').Ref<import('@/types/api').Paciente>} */
  const pacienteSelecionado = ref({})
  const abaSelecionada = ref('identificacao')

  const erroNome = ref("")
  const erroEmail = ref("")
  const erroTelefone = ref("")
  const erroGeral = ref("")

  const resetarFormulario = () => {
    erroNome.value = ""
    erroEmail.value = ""
    erroTelefone.value = ""
    erroGeral.value = ""
    abaSelecionada.value = "identificacao"
    pacienteSelecionado.value = {}
  }

  const sanitize = options.sanitizePaciente || ((p) => p) // fallback: retorna como está

  function abrirVisualizacao(paciente) {
    pacienteSelecionado.value = sanitize(paciente)
    modoEdicao.value = false
    modoCadastro.value = false
    abaSelecionada.value = 'identificacao'
    mostrarModal.value = true
  }

  // 🟡 Abre o modal para edição de um paciente existente
  function abrirEdicao(paciente) {
    if (!paciente || Object.keys(paciente).length === 0) {
        return;
    }
    pacienteSelecionado.value = sanitize(paciente)
    modoEdicao.value = true
    modoCadastro.value = false
    abaSelecionada.value = 'identificacao'
    mostrarModal.value = true
  }

  function abrirCadastro() {
    pacienteSelecionado.value = {
        primeiro_nome: "",
        sobrenome: "",
        dn: "1900-01-01",
        idade: 0,
        sexo: "O",
        indicacao_clinica: "",
        forma_de_capitacao: "Não informado",
        sistema_inscrito: "DIETSYSTEM",
        uf: "NA",
        telefone_formatado: "",
        email: "",
        receber_email: true,
        motivo_nao_email: "não informado",
        receber_whatsapp: true,
        motivo_nao_whatsapp: "não informado"
    }
    modoEdicao.value = false
    modoCadastro.value = true
    abaSelecionada.value = 'identificacao'
    mostrarModal.value = true
  }

  function fecharModal() {
    mostrarModal.value = false
    modoEdicao.value = false
    modoCadastro.value = false
    resetarFormulario()
  }

  return {
    mostrarModal,
    modoEdicao,
    modoCadastro,
    pacienteSelecionado,
    abaSelecionada,
    erroNome,
    erroEmail,
    erroTelefone,
    erroGeral,

    abrirVisualizacao,
    abrirEdicao,
    abrirCadastro,
    fecharModal,
    resetarFormulario
  }
}
